import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import moment from 'moment'
import { useState } from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'
import CampaignCapWatchModal from '../../../components/CampaignCapWatchModal/CampaignCapWatchModal'
import { useAuth, useProtectedContent } from '../../../context/AuthContext'
import callAPI from '../../../helpers/callAPI'
import getJobName from '../../../helpers/getJobName'
import useCallApi from '../../../hooks/useCallApi'
import { FaExternalLinkAlt } from 'react-icons/fa'

import Advertiser from '../../../templates/Advertiser/Advertiser'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'

const CampaignInfo = ({ campaign, refetch, showSystemMessage }) => {
    const auth = useAuth()

    const dayLabelById = {
        0: 'Monday',
        1: 'Tuesday',
        2: 'Wednesday',
        3: 'Thursday',
        4: 'Friday',
        5: 'Saturday',
        6: 'Sunday'
    }

    const [modal, setModal] = useState({ open: false, id: 0, campaign: false, type: false, cap: false })
    const auth_addCapWatch = useProtectedContent(auth.permissions, 'add_cap_watch')
    const showCampaignSettings = useProtectedContent(auth.permissions, 'campaign_settings')
    const showEditJob = useProtectedContent(auth.permissions, 'scheduled_jobs')
    const [manager, setManager] = useState(auth.user)
    const [deleting, setDeleting] = useState(false)

    const { data: capwatchData, dataLoaded: capwatchDataLoaded } = useCallApi(`campaigns/capWatch/${manager.id}`, 'GET', {}, [manager.id])

    const handleCloseModal = () => {
        setModal({ open: false, id: 0, campaign: false, type: false, cap: false })
    }

    const deleteWatch = (capWatchId) => {
        setDeleting(true)

        let url = `campaigns/capWatch/${manager.id}`

        callAPI(url, 'DELETE', { id: capWatchId })
            .then((result) => {
                if (result['success'] === true) {
                    refetch()
                    showSystemMessage('success', 'Cap watch deleted.')
                } else if (result['success'] === false) {
                    refetch()
                    setDeleting(false)
                    showSystemMessage('error', 'An error occurred while deleting cap watch.')
                }
            })
            .catch((error) => {
                console.log(`Error while deleting cap watch: ${error}`)
                showSystemMessage('error', 'An error occurred while deleting cap watch.')
                setDeleting(false)
            })
    }

    const getCopyDetailsImage = () => {
        let text = campaign.name + ' - ID: ' + campaign.id + '\nLanding Page Preview:\n'
        let rateText = ''
        
        let campaignPreviewImage = `${process.env.REACT_APP_TRACKING_CDN_URL}/creative/lp?m=${campaign.advertiser_id}&o=${campaign.id}&l=${campaign.landing_pages[0]?.lp_record_id}&s=full`

        text += campaignPreviewImage + '\nCommission Details:\n'

        rateText = campaign.rates.map((rate) => { if (rate.status === 'A') {return rateText + rate.description + ' : ' + (rate.display_rate_text !== '' ? rate.display_rate_text : rate.affiliate_rate_text) + '\n'} else {return ''} })
        text += rateText.toString().replace(/,/g, '')
        text += '\nFull details found here: ' + 'https://affiliates.maxbounty.com/campaign/' + campaign.id
        return text
    }

    const getCopyDetailsUrl = () => {
        let text = campaign.name + ' - ID: ' + campaign.id + '\nDefault Landing Page:\n'
        let rateText = ''
        let defaultLandingPageUrl = ''
        // get default landing page link with filter function
        if (campaign.visible_url) {
            defaultLandingPageUrl = campaign.visible_url
        } else {
            let theDefault = campaign.landing_pages.filter((lp) => lp.default_flag === 'Y')
            defaultLandingPageUrl = theDefault[0] ? theDefault[0].landing_url : ''
        }

        text += defaultLandingPageUrl + '\n\nCommission Details:\n'

        rateText = campaign.rates.map((rate) => { if (rate.status === 'A') {return rateText + rate.description + ' : ' + (rate.display_rate_text !== '' ? rate.display_rate_text : rate.affiliate_rate_text) + '\n'} else {return ''} })
        text += rateText.toString().replace(/,/g, '')

        text += '\nFull details found here: ' + 'https://affiliates.maxbounty.com/campaign/' + campaign.id
        return text
    }

   const formatMinutes = (minutes) => {
        const hours = Math.floor(minutes / 60)
        const mins = minutes % 60

        return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`
    }

    const getDisplayData = (dayPartingData) => {
        if (!Array.isArray(dayPartingData)) {
            return []
        }

        let newArray = []

        dayPartingData.forEach((item) => {
            const existingDayIndex = newArray.findIndex((day) => day.day_id === item.day_id)

            if (existingDayIndex !== -1) {
                newArray[existingDayIndex].times.push({
                    id: item.id,
                    time: `${item.start_time_minute}-${item.end_time_minute}`
                })
            } else {
                newArray.push({
                    day_id: item.day_id,
                    times: [{
                        id: item.id,
                        time: `${item.start_time_minute}-${item.end_time_minute}`
                    }]
                })
            }
        })

        return newArray
    }

    const daypartingDisplayData = getDisplayData(campaign.dayparting.schedule)

    return (
        <div className="card pt-2 mb-2">
            <CampaignCapWatchModal key={modal.id} manager={manager} campaign={{ id: campaign.id, name: campaign.name }} open={modal.open} close={handleCloseModal} refetch={refetch} showSystemMessage={showSystemMessage} />
            <div className="d-flex justify-content-between border-bottom p-2 align-items-center">
                <div>
                    <div>
                        <h5 className="font-weight-bold">
                            {
                                showCampaignSettings ?
                                    <Link className={`${campaign.status.name === 'Cancelled' ? 'text-danger' : ''}`} to={`/campaign/${campaign.id}/settings`}>
                                        {campaign.name} ({campaign.id})
                                    </Link>
                                    :
                                    <>{campaign.name} ({campaign.id})</>
                            }
                        </h5>
                    </div>                    
                </div>
               
                            <div>
                                <button className="btn btn-warning btn-sm" onClick={() => setModal({ open: true, id: 0, campaign: { id: campaign.id, name: campaign.name } })}>
                                    Watch Cap
                                </button>
                            </div>
                        
            </div>
            <div className="p-2 border-bottom">
                Advertiser: <Advertiser id={campaign.advertiser.id} name={campaign.advertiser.name} status={campaign.advertiser.status.value} />
                <span className="text-secondary ml-2"> / Manager: {campaign.advertiser.manager.name} / Bizdev: {campaign.advertiser.bizdev_manager ? campaign.advertiser.bizdev_manager.name : ''}</span>
            </div>
            <div className="p-2 border-bottom d-flex justify-content-between">
                <div>
                    <span className={`mb-pill ${campaign.status.name === 'Cancelled' ? 'text-danger' : campaign.status.name === 'Active' ? 'text-success' : ''}`}>{campaign.status.name}</span>
                    <span className="mb-pill">{moment.utc(campaign.expiry_date).year() === 2099 ? `Doesn't Expire` : `Expires on ${moment.utc(campaign.expiry_date).format('YYYY-MM-DD HH:mm:ss')}`}</span>
                    <span className="mb-pill">{campaign.tracking.type.name} Tracking</span>
                </div>
                <div>
                    {campaign.type.name === 'Avatar' && <span className="mb-pill">Avatar</span>}
                    {campaign.tracking.is_mobile_offer && <span className="mb-pill">📱 Mobile Campaign</span>}
                    {campaign.mobile_optimized && <span className="mb-pill">📱 Mobile Optimized</span>}
                </div>
            </div>
            {
                campaign.scheduled_jobs.length > 0 &&
                    <div className="p-2 border-bottom">
                        {
                            campaign.scheduled_jobs.map( job => {
                                return <div key={job.id}><span className="text-secondary"><FontAwesomeIcon icon="calendar-alt" /></span> Scheduled to {getJobName(job.name)}{job.rate_name ? ` (${job.rate_name})` : ''} on {moment(job.date).utc().format('YYYY-MM-DD HH:mm:ss')} {showEditJob && <Link to='/admin/jobs'><FontAwesomeIcon icon="pencil-alt" /></Link>}</div>})
                        }                        
                    </div>
            }            
            <div className="p-2 border-bottom d-flex justify-content-between align-items-center">
                <div>
                    <CopyToClipboard text={getCopyDetailsImage()}>
                        <button type="button" className="btn btn-sm btn-outline-primary mr-3">
                            <FontAwesomeIcon icon="copy" /> Copy (Image)
                        </button>
                    </CopyToClipboard>

                    <CopyToClipboard text={getCopyDetailsUrl()}>
                        <button type="button" className="btn btn-sm btn-outline-primary">
                            <FontAwesomeIcon icon="copy" /> Copy (URL)
                        </button>
                    </CopyToClipboard>
                </div>
                <div>
                    <a target="_blank" href={campaign.visible_url}>Preview Lander <FaExternalLinkAlt color="#007bff" /></a>
                </div>                
            </div>
            <div className="p-2 border-bottom" dangerouslySetInnerHTML={{ __html: campaign.description }} />
            {campaign.notes.general && <div className="p-2" dangerouslySetInnerHTML={{ __html: campaign.notes.general }}></div>}
            {
                campaign.dayparting.enabled && 
                    <div className="p-2 border-top border-top">
                        <strong>Dayparting:</strong>
                        <table className="table table-sm mb-3 table-striped table-hover border-bottom">
                            <thead>
                                <tr>
                                    <th>Day</th>
                                    <th>Schedule</th>
                                </tr>
                            </thead>
                            <tbody>
                                {daypartingDisplayData.length > 0 ? (
                                    daypartingDisplayData.map((item) => (
                                        <tr key={item.day_id}>
                                            <td>{dayLabelById[item.day_id] || item.day_id}</td>
                                            <td>
                                                {item.times.map((time) => (
                                                    <div key={time.id} className="d-flex align-items-center">
                                                        {formatMinutes(time.time.split('-')[0])} - {formatMinutes(time.time.split('-')[1])}
                                                    </div>
                                                ))}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="2" className="text-muted">No day parting.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
            }
            {campaign.prepop && <div className="p-2 border-top">
                <div className="font-weight-bold">Prepop Instructions:</div>
                <div className="ml-2" dangerouslySetInnerHTML={{ __html: campaign.prepop }}></div>
            </div>}
            {campaign.coupon && <div className="p-2 border-top">
                <div className="font-weight-bold">Coupon:</div>
                <div className="ml-2" dangerouslySetInnerHTML={{ __html: campaign.coupon }}></div>
            </div>}
        </div>
    )
}

export default CampaignInfo
